import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import { Icon, IconClose } from '@flixbus/honeycomb-icons-react';
import PropTypes from 'prop-types';
import Button from '../button.js';

/** @since 8.0.0 */
function CloseButton(_a) {
  var {
      'aria-label': ariaLabel
    } = _a,
    rest = __rest(_a, ['aria-label']);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    display: "square",
    appearance: "link",
    "aria-label": ariaLabel
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    InlineIcon: IconClose,
    "aria-hidden": "true"
  }));
}
CloseButton.propTypes = {
  'aria-label': PropTypes.string.isRequired
};

export { CloseButton };
